/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EncryptTextCommand = {
  plainText?: string;
  cryptoType?: EncryptTextCommand.cryptoType;
};
export namespace EncryptTextCommand {
  export enum cryptoType {
    KSW = 'KSW',
    HSW = 'HSW',
  }
}

